import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import LoadingPage from "../components/LoadingPage";
import { insertRegistration } from "../../services2/registrations.service";
import { insertPrimaryRegistration } from "../../services2/pregistrations.service";
import FileDropzone from "./components/FileDropZone";
import DotdotdotSvg from '../../svg/website/Dotdotdot';
import RegisterHeroSvg from '../../svg/website/RegisterHero';
import UploadSvg from '../../svg/website/UploadSvg';
import Footer from "./components/Footer";
import './home.css'
import { uploadPhotoNoAuth } from "../../services2/s3.service";
import DropDownMenu from "../components/DropDownMenu";
//
import SignupStepm from '../../svg/website/mobile/SignupStepm'
import SignupUpload from '../../svg/website/mobile/SignupUpload'
import RegistrationBg from '../../svg/website/RegistrationBg';
import PrimaryButton from '../../svg/website/PrimaryButton';
import SecondaryButton from '../../svg/website/SecondaryButton';

const validateEmail = (email) => {
    return String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
};

export default function Home() {
    const navigate = useNavigate();
    const location = useLocation();
    const navigateTo = (str) => () => {
        navigate(str)
    }
    let [searchParams, setSearchParams] = useSearchParams();
    const type = searchParams.get('type')||null;
    const isPrimary = type === 'primary' ? true : type==='secondary' ? false : null;
    const [isloading, setisloading] = useState(false);
    const [data, setData] = useState({})
    const [showRegisterError, setshowRegisterError] = useState('')
    const [isShowSuccessfulPage, setisShowSuccessfulPage] = useState(false)
    const handleCompleteRegister = async () => {
        if (isPrimary === null) {
            alert('請選擇學校類型');
            return
        }
        if (!data.schoolName) {
            alert('請填寫學校名稱');
            return
        }
        if (!data.teacherEmail) {
            alert('請填寫老師電郵');
            return
        }
        if (!validateEmail(data.teacherEmail)) {
            alert('老師電郵格式不正確');
            return
        }
        if (!data.teacherName) { alert('請填寫負責老師'); return; }
        if (!data.teacherTel) { alert('請填寫老師電話'); return }
        if (!tempFile) { alert('請上傳報名表'); return }
        if (!data.isAcknowledged) { alert('請閱讀並同意聲明'); return }
        if (!isReady()) return
        //start upload
        setisloading(true)

        const fileRes = await uploadPhotoNoAuth(tempFile, 'register', Date.now())
        if (fileRes.errno) {
            return alert('請稍後重試');
        }
        const newData = {
            ...data,
            teacherEmail: data.teacherEmail.toLowerCase(),
            attachment: fileRes.result
        }
        let result = isPrimary
            ? await insertPrimaryRegistration(newData)
            : await insertRegistration(newData)
        if (result?.errno) {
            setshowRegisterError(result?.message || 'error')
            setisloading(false)
            return
        } else {
            setisShowSuccessfulPage(true)
            setisloading(false)
        }
    }



    const isReady = () => {
        if (!data.schoolName) { return false }
        if (!data.teacherEmail) { return false }
        if (!data.teacherName) { return false }
        if (!data.teacherTel) { return false }
        if (!data.isAcknowledged) { return false }
        if (!tempFile) { return false }
        return true
    }
    const [tempFile, setTempFile] = useState(null)
    const onDropImageFile = async (files) => {
        if (files.length > 1) {
            alert(`Only one file is allowed.`)
            return
        }
        const file = files[0]
        if (!['image/png', 'image/jpeg', 'application/pdf'].includes(file.type)) {
            alert(`File type ${file.type} is not allowed`)
            return
        }
        if (file.size > 1024 * 1024 * 2) {
            alert(`File size must be within 2 MB`)
            return
        }

        let formData = new FormData();
        formData.append('file', file, file.name);
        formData.append('json', JSON.stringify({}));
        setisloading(true);
        setTempFile(formData);
        setisloading(false);
    }

    const openNewTab = (url) => () => {
        window.open(url, '_blank').focus();
    }

    const scrollToTop = () => {
        document.getElementById('navbar').scrollIntoView({})
    }
    useEffect(() => {
        scrollToTop()
    }, [location])

    const setTypeAs = (type) => () => {
        setSearchParams({ type: type })
    }

    if (isShowSuccessfulPage) return (
        <div className="w-full h-full flex flex-col items-center bg-main justify-start p-[16px] bg-[#ddd]" style={{ overflowY: 'auto' }}>

            <div className="relative w-full max-w-[1300px]">
                <div className="relative w-full border-white border-2 p-[24px] rounded-[50px] flex flex-col justify-start items-center mt-[64px] overflow-hidden">
                    <div className='absolute bottom-0 w-full h-full' style={{ background: 'linear-gradient(180deg, rgba(255, 255, 255, 0) 69%, rgba(255, 255, 255, 0.6) 87.5%, #FFFFFF 100%)', zIndex: 1, }} />
                    <div className="flex flex-col w-full items-center gap-[16px] text-center" style={{ zIndex: 2 }}>
                        <div className="font-[700] text-[32px] text-[#425596] text-center mt-[24px]">學校登記</div>


                        <div className="font-[400] d-text-28-m-22 text-[#425596] mt-[16px]">
                            <div className='text-black font-[700]' style={{ display: 'inline-block' }}>{data?.schoolName}</div> ,我們衷心感謝您的註冊。
                        </div>
                        <div className="font-[400] d-text-28-m-22 text-[#425596] mt-[-16px]">
                            以下是你的登記資料
                        </div>
                        <div className="font-[400] text-[18px] text-[#425596] mt-[12px]">
                            電郵地址 &nbsp;&nbsp; {data?.teacherEmail}
                        </div>
                        <div className="font-[350] d-text-28-m-22 text-[#425596] mt-[12px]">
                            您已登記成功，我們正在確認您的信息，並將於近日內發送確認電子郵件給您。
                        </div>



                    </div>
                </div>
            </div>
        </div>
    )
    if(['primary', 'secondary'].includes(type) === false) {
        return (
            <div className="relative w-full h-full flex flex-col items-center bg-main justify-between p-[16px] bg-[#ddd]" style={{ overflowY: 'auto' }}>
                <div className="relative w-full max-w-[1300px] flex flex-row flex-wrap items-center justify-center mt-[64px] gap-[64px]">
                    <div onClick={setTypeAs('secondary')} className="cursor-pointer">
                        <SecondaryButton/>
                    </div>
                    <div onClick={setTypeAs('primary')} className="cursor-pointer">
                        <PrimaryButton/>
                    </div>
                    {/* <div className="cursor-pointer hover:opacity-80 transition-all duration-300 border-[4px] border-[white] rounded-[10px] px-[24px] py-[12px] text-[#425596] font-[700] text-[24px] bg-[rgb(171,239,228)] min-w-[200px] min-h-[130px] flex justify-center items-center text-center" onClick={setTypeAs('secondary')}>
                        中學登記<br/>
                        Secondary
                    </div>
                    <div className="cursor-pointer hover:opacity-80 transition-all duration-300 border-[4px] border-[white] rounded-[10px] px-[24px] py-[12px] text-[#425596] font-[700] text-[24px] bg-[rgb(171,239,228)] min-w-[200px] min-h-[130px] flex justify-center items-center text-center" onClick={setTypeAs('primary')}>
                        小學登記<br/>
                        Primary
                    </div> */}
                </div>
                <div className="w-full my-[64px]">
                    <RegistrationBg width='100%'/>
                </div>
            </div>
        )
    }
    return (
        <div className="w-full flex flex-col items-center justify-start bg-main pb-[64px] relative">
            <img src='./home/backdroplogo.png' className="absolute w-[50%] left-[-20px] top-[12%] d-flex-m-hidden"></img>
            <div className="relative w-full max-w-[1300px] p-[16px]">
                <div className="font-[700] text-[55px] text-[#425596] text-center flex flex-row items-start justify-center">
                    學校登記
                    <DotdotdotSvg />
                </div>
            </div>
            <div className="d-flex-m-hidden w-full">
                <RegisterHeroSvg width='100%' handleClick={openNewTab('/簡易簡介小冊子.pdf')} />
            </div>
            <div className="d-hidden-m-flex w-full">
                <SignupStepm width='100%' handleClick={openNewTab('/簡易簡介小冊子.pdf')} />
            </div>
            <div className="relative w-full max-w-[1300px] p-[16px]">
                <div className="font-[500] text-[20px] text-[#425596] text-center mt-[38px]">
                    請提供您的更多信息，用於網讀無界平台的報名登記
                </div>
                <div className="relative w-full rounded-[50px] flex flex-col justify-center items-center mt-[64px] overflow-hidden">
                    <div className='absolute w-full h-full top-0 left-0 bg-[#FFFFFFE5]' style={{ zIndex: 0, opacity: 0.6 }}></div>
                    <div className="flex flex-col w-full items-center gap-[16px] py-[69px] max-w-[1400px] BgGlass" style={{ zIndex: 2 }}>

                        {/* <div className="w-full flex flex-col items-start gap-[8px] w-full pt-[8px]">
                            <div className="text-[#425596] font-[600] text-[28px] flex flex-row items-end">學校電郵</div>
                            <div className="flex flex-row w-full gap-[12px]">
                                <div className="flex-1 pb-[8px] h-full" style={{borderBottom:'2px solid #00E9BA'}}>
                                    <input onChange={(e)=>{
                                        setData({...data,schoolEmail:e.target.value})
                                    }} value={data?.schoolEmail||''} className="w-full bg-[transparent]" placeholder="請填寫"/>
                                </div>
                            </div>
                        </div> */}
                        {showRegisterError &&
                            <div className="text-[red] font-[600] text-[28px] flex flex-row items-left w-full w-full px-[50px]">
                                {showRegisterError}
                            </div>
                        }

                        {/* <div className="w-full flex flex-col items-start gap-[8px] w-full pt-[8px] px-[50px]">
                            <div className="text-[#425596] font-[600] text-[28px] flex flex-row items-end">小學/中學<span className="text-[#ff0000]">*</span> <div className="text-[12px]"></div></div>
                            <div className="flex flex-row w-full gap-[12px]">
                                <DropDownMenu
                                    className="flex-1 pb-[8px] h-full"
                                    style={{ border: '2px solid #00E9BA' }}
                                    options={['小學', '中學']}
                                    value={isPrimary === null ? '請選擇' : isPrimary ? '小學' : '中學'}
                                    select={(value) => {
                                        setisPrimary(value === '小學')
                                    }}
                                />
                            </div>
                        </div> */}
                        <div className="w-full flex flex-col items-start gap-[8px] w-full pt-[8px] px-[50px]">
                            <div className="text-[#425596] font-[600] text-[28px] flex flex-row items-end">學校英文名稱<span className="text-[#ff0000]">*</span> <div className="text-[12px]"></div></div>
                            <div className="flex flex-row w-full gap-[12px]">
                                <div className="flex-1 pb-[8px] h-full" style={{ borderBottom: '2px solid #00E9BA' }}>
                                    <input onChange={(e) => { setData({ ...data, schoolName: e.target.value }) }} value={data?.schoolName || ''} className="w-full bg-[transparent]" placeholder="請填寫英文" />
                                </div>
                            </div>
                        </div>
                        <div className="w-full flex flex-col items-start gap-[8px] w-full pt-[8px] px-[50px]">
                            <div className="text-[#425596] font-[600] text-[28px] flex flex-row items-end">校長姓名 <div className="text-[12px]"></div></div>
                            <div className="flex flex-row w-full gap-[12px]">
                                <div className="flex-1 pb-[8px] h-full" style={{ borderBottom: '2px solid #00E9BA' }}>
                                    <input onChange={(e) => { setData({ ...data, principalName: e.target.value }) }} value={data?.principalName || ''} className="w-full bg-[transparent]" placeholder="請填寫" />
                                </div>
                            </div>
                        </div>

                        <div className="w-full flex flex-row-col items-start gap-[8px] w-full pt-[8px] px-[50px]">
                            <div className="flex flex-col items-start flex-1 w-full">
                                <div className="text-[#425596] font-[600] text-[28px] flex flex-row items-end">學校電話 <div className="text-[12px]"></div></div>
                                <div className="flex flex-row w-full gap-[12px]">
                                    <div className="flex-1 pb-[8px] h-full" style={{ borderBottom: '2px solid #00E9BA' }}>
                                        <input onChange={(e) => { setData({ ...data, schoolTel: e.target.value }) }} value={data?.schoolTel || ''} className="w-full bg-[transparent]" placeholder="請填寫" />
                                    </div>
                                </div>
                            </div>
                            <div className="flex flex-col items-start flex-1 w-full">
                                <div className="text-[#425596] font-[600] text-[28px] flex flex-row items-end">學校傳真 <div className="text-[12px]"></div></div>
                                <div className="flex flex-row w-full gap-[12px]">
                                    <div className="flex-1 pb-[8px] h-full" style={{ borderBottom: '2px solid #00E9BA' }}>
                                        <input onChange={(e) => { setData({ ...data, schoolFax: e.target.value }) }} value={data?.schoolFax || ''} className="w-full bg-[transparent]" placeholder="請填寫" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="w-full flex flex-row-col items-start gap-[8px] w-full pt-[8px] px-[50px]">
                            <div className="flex flex-col items-start flex-1 w-full">
                                <div className="text-[#425596] font-[600] text-[28px] flex flex-row items-end">負責老師<span className="text-[#ff0000]">*</span> <div className="text-[12px]"></div></div>
                                <div className="flex flex-row w-full gap-[12px]">
                                    <div className="flex-1 pb-[8px] h-full" style={{ borderBottom: '2px solid #00E9BA' }}>
                                        <input onChange={(e) => { setData({ ...data, teacherName: e.target.value }) }} value={data?.teacherName || ''} className="w-full bg-[transparent]" placeholder="請填寫" />
                                    </div>
                                </div>
                            </div>
                            <div className="flex flex-col items-start flex-1 w-full">
                                <div className="text-[#425596] font-[600] text-[28px] flex flex-row items-end">老師電話<span className="text-[#ff0000]">*</span> <div className="text-[12px]"></div></div>
                                <div className="flex flex-row w-full gap-[12px]">
                                    <div className="flex-1 pb-[8px] h-full" style={{ borderBottom: '2px solid #00E9BA' }}>
                                        <input onChange={(e) => { setData({ ...data, teacherTel: e.target.value }) }} value={data?.teacherTel || ''} className="w-full bg-[transparent]" placeholder="請填寫" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="w-full flex flex-col items-start gap-[8px] w-full pt-[8px] px-[50px]">
                            <div className="text-[#425596] font-[600] text-[28px] flex flex-row items-end">老師電郵<span className="text-[#ff0000]">*</span> <div className="text-[12px]"></div></div>
                            <div className="flex flex-row w-full gap-[12px]">
                                <div className="flex-1 pb-[8px] h-full" style={{ borderBottom: '2px solid #00E9BA' }}>
                                    <input onChange={(e) => { setData({ ...data, teacherEmail: e.target.value }) }} value={data?.teacherEmail || ''} className="w-full bg-[transparent]" placeholder="請填寫" />
                                </div>
                            </div>
                        </div>
                        <div className="w-full flex flex-col items-start gap-[8px] w-full pt-[8px] px-[50px]">
                            <div className="text-[#425596] font-[600] text-[28px] flex flex-row items-end">備注 <div className="text-[12px]"></div></div>
                            <div className="flex flex-row w-full gap-[12px]">
                                <div className="flex-1 pb-[8px] h-full" style={{ borderBottom: '2px solid #00E9BA' }}>
                                    <input onChange={(e) => { setData({ ...data, remarks: e.target.value }) }} value={data?.remarks || ''} className="w-full bg-[transparent]" placeholder="請填寫" />
                                </div>
                            </div>
                        </div>
                        <div className="d-flex-m-hidden w-full">
                            <UploadSvg width='100%' />
                        </div>
                        <div className="d-hidden-m-flex w-full">
                            <SignupUpload width='100%' />
                        </div>
                        <div className="w-full flex flex-col items-start gap-[8px] w-full pt-[8px] px-[50px]">
                            <div className="text-[#425596] font-[600] text-[28px] flex flex-row items-end">上傳報名表<span className="text-[#ff0000]">*</span> <div className="text-[12px]"></div></div>
                            <div className="border px-[48px] py-[12px] rounded-[12px] mt-[24px] flex items-start w-full" style={{ border: '2px solid #425596' }}>
                                <FileDropzone tempFile={tempFile} onDropFile={onDropImageFile} />
                            </div>
                        </div>

                        <div className="w-full flex flex-row w-full flex-wrap px-[50px]">
                            <div className="d-flex2-m-100 flex flex-col items-start gap-[8px] py-[8px]">
                                <div className="text-[#425596] font-[600] text-[28px] flex flex-row items-end">
                                    聲明 <div className="text-[12px]"></div>
                                </div>

                                <div className="flex flex-row w-full gap-[24px] text-[11px] font-[700] text-[#425596]" style={{}}>
                                    <div onClick={(e) => { setData({ ...data, isAcknowledged: !data.isAcknowledged }) }} className="min-w-[19px] min-h-[19px] max-w-[19px] max-h-[19px] rounded-[2px] p-[2px] cursor-pointer" style={{ border: '2px solid #00E9BA' }}>
                                        {(data?.isAcknowledged || false) && <div className="w-full h-full bg-[#00E9BA]"></div>}
                                    </div>
                                    {/* <input type="checkbox" className="" checked={data?.isAcknowledged||false} onChange={(e)=>{setData({...data,isAcknowledged:!data.isAcknowledged})}}/>  */}
                                    <div>
                                        本人謹此聲明，本人就此項申請所提供之一切資料均屬真實有效，如有虛報本人之申請將會被取消。本人授權網讀無界平台使用本人提供之資料作統計、活動等指定用途。
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex flex-row items-center justify-center mt-[40px]">
                    <div onClick={handleCompleteRegister} className="max-w-[265px] px-[80px] py-[8px] register-button mt-[16px] cursor-pointer flex justify-center items-center d-text-24-m-14 font-[700] rounded-[99px] text-[#425596]" style={{ background: '#00E9BA4D', border: '3px solid #00E9BA', opacity: isReady() ? 1 : 0.3 }}>
                        登記
                    </div>
                </div>
                <div className="w-full mt-[160px] flex flex-col">
                    <Footer />
                </div>
            </div>
            {isloading && <LoadingPage />}
        </div>
    )
}